<template>
  <a
    class="product-cart-buttom"
    :class="{ 'product-cart-buttom--primary': primary }"
    :href="href"
    rel="nofollow"
    @click="onClick"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'product-cart-buttom',
  props: {
    href: {
      type: String,
      default: '#',
    },
    primary: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss">
@import './product-cart-buttom';
</style>
